<template>
  <v-card>
    <v-row class="pt-4 px-3 ma-0">
      <v-col
        cols="12"
        md="3"
      >
        <v-text-field
          v-model="filter.search"
          append-icon="mdi-magnify"
          label="Search"
          single-line
          outlined
          width="20"
          dense
          hide-details
          clearable
          @input="updateQuery"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-select
          v-model="filter.state"
          label="Filter by State"
          :items="ngstate"
          outlined
          dense
          clearable
          @input="updateQuery"
        >
        </v-select>
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-select
          v-model="filter.lga"
          label="Filter by Lga"
          :items="nglga[ngstate]"
          outlined
          dense
          clearable
          @input="updateQuery"
        >
        </v-select>
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-text-field
          v-model="filter.phone"
          append-icon="mdi-magnify"
          label="Filter by Phone"
          single-line
          outlined
          width="20"
          dense
          clearable
          hide-details
          @input="updateQuery"
        ></v-text-field>
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <v-select
          v-model="filter.gender"
          label="Filter Gender"
          :items="genders"
          outlined
          width="20"
          dense
          clearable
          @input="updateQuery"
        ></v-select>
      </v-col>
    </v-row>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="enumerators"
      show-select
      item-key="item._id"
    >
      <template v-slot:top>
        <v-toolbar flat colour="white">
          <v-toolbar-title>Enumerators</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="ma-2"
            text
            >
              <v-icon left>mdi-filter</v-icon>
                filter
            </v-btn>
            <v-btn
            color="primary"
            class="ma-2"
            text
            >
              <v-icon left>mdi-download</v-icon>
                Export
            </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:[`item.photo`] = "{ item }">
        <v-avatar size="30">
          <img :src= "`http://localhost:5000/${item.photo}`">
        </v-avatar>
      </template>
      <!--fullname//////////////-->
      <template v-slot:[`item.full_name`] = "{ item }">
        {{ item.first_name }} {{ item.last_name }}
      </template>
      <template v-slot:[`item.actions`] = "{ item }">
        <v-btn
          color="primary"
          class="ml-n2"
          depressed
          small
          @click="editEnumerator(item._id)"
        >
          More
        </v-btn>
      </template>
      <template v-slot:[`item.count`]="{ item }">
        <v-btn
          color="primary"
          depressed
          class="ml-1"
          small
          @click="getFarmer(item._id)"
        >
          {{ item.count }}
        </v-btn>
      </template>
      <template v-slot:[`item.status`] = "{ item }">
        <v-chip
          :color="getColor(item.status)"
          class="ml-n2"
          outlined
          small
        >
          {{ item.status }}
        </v-chip>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
// import EnumeratorService from '../services/EnumeratorService'
// import FarmerCounterService from '../services/FarmerCounterService'
import { ngstate, nglga, genders } from '../utils/Statelga'
export default {
  data () {
    return {
      props: ['enumerators'],
      ngstate,
      nglga,
      genders,
      search: '',
      error: '',
      count: '',
      selected: [],
      headers: [
        {
          text: '',
          align: 'start',
          value: 'photo',
          sortable: false
        },
        { text: 'Farmers', value: 'full_name' },
        { text: 'Phone', value: 'phone' },
        { text: 'Email', value: 'email' },
        { text: 'State', value: 'state' },
        { text: 'LGA', value: 'lga' },
        { text: 'Job Count', value: 'count' },
        { text: 'Status', value: 'status' },
        { text: 'Actions', value: 'actions' }
      ],
      enumerators: []
    }
  },
  /* async created () {
    const enumerators = await EnumeratorService.getEnumerators()

    const promises = enumerators.map(async (enumerator) => {
      enumerator.count = await FarmerCounterService.getCount(enumerator._id)
    })
    await Promise.all(promises)
    this.enumerators = enumerators
  }, */
  methods: {
    getColor (status) {
      if (status === 'Inactive') return 'red'
      else return 'green'
    },
    editEnumerator (id) {
      this.$router.push({ name: 'Enumerator', params: { id: id } })
    },
    getFarmer (id) {
      this.$router.push({ name: 'Farmerstable', query: { enumeratorid: id } })
      // :to="{ path: 'farmers', query: { enumerator_id: item._id} }"
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
